import { render } from "./ProductFeaturesslider.vue?vue&type=template&id=5ac45c07&scoped=true"
import script from "./ProductFeaturesslider.vue?vue&type=script&lang=js"
export * from "./ProductFeaturesslider.vue?vue&type=script&lang=js"

import "./ProductFeaturesslider.vue?vue&type=style&index=0&id=5ac45c07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac45c07"]])

export default __exports__